import { Button } from "@clockwise/design-system";
import React from "react";

type Props = {
  disabled?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitText: string;
};
export const ChatInputSubmitCancelButtons = ({
  disabled = false,
  onCancel,
  onSubmit,
  submitText,
}: Props) => (
  <div className="cw-bg-default cw-px-3 cw-pb-2 cw-flex cw-flex-row cw-justify-end cw-space-x-1">
    <Button disabled={disabled} variant="text" size="mini" onClick={onCancel}>
      Cancel
    </Button>
    <Button disabled={disabled} onClick={onSubmit} sentiment="positive" size="mini" variant="solid">
      {submitText}
    </Button>
  </div>
);
